import { render, staticRenderFns } from "./ElementsHeadlinePreview.vue?vue&type=template&id=a66333e0"
import script from "./ElementsHeadlinePreview.vue?vue&type=script&lang=js"
export * from "./ElementsHeadlinePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports